import { useEffect, useState } from "react";
import { fetchConfig } from "@/lib/api";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import VehicleCategories from "@/components/VehicleCategories";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import Configurator from "@/components/Configurator";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const FALLBACK = {
  company: {
    name: "VPT Operations GmbH",
    street: "Römerweg 1c",
    postal_code: "8434",
    city: "Tillmitsch",
    country: "AT",
    email: "tuningfiles@vmaxx.at",
    contact: "Buchhaltung",
    phone: "",
    vat_id: "ATU81130447",
  },
  contact: {
    email: "tuningfiles@vmaxx.at",
    whatsapp: "",
    portal_url: "https://portal.tuningfiles-online.com",
  },
  konfigurator: {
    base_url: "https://konf.vpt.fileservice.app",
    license_key: "",
    text_color: "#ffffff",
    accent_color: "#fbff00",
    pulse_color: "#fff700",
    pulse_enabled: "true",
    dyno_enabled: "true",
  },
};

export default function Home() {
  const [config, setConfig] = useState(FALLBACK);

  useEffect(() => {
    fetchConfig()
      .then((data) => setConfig({ ...FALLBACK, ...data }))
      .catch(() => setConfig(FALLBACK));
  }, []);

  const portalUrl = config?.contact?.portal_url || FALLBACK.contact.portal_url;

  return (
    <main className="relative bg-background text-foreground">
      <Header portalUrl={portalUrl} />
      <Hero portalUrl={portalUrl} />
      <Marquee />
      <Stats />
      <VehicleCategories />
      <Services />
      <Manifesto />
      <Configurator konfigurator={config.konfigurator} portalUrl={portalUrl} />
      <Faq />
      <Contact config={config} />
      <Footer config={config} portalUrl={portalUrl} />
    </main>
  );
}
